import { appUrl } from '@/utils/appUrl';

const renderShippingId = (value: string) => {
  return (
    <a
      style={{ color: 'var(--primary-color)' }}
      href={appUrl(`/business/shipping/${encodeURIComponent(value)}`)}
      target='_blank'
      rel='noreferrer'
    >
      {value}
    </a>
  );
};

export default renderShippingId;
